import React from 'react';
import { observer, inject } from 'mobx-react';


import RevertButton from 'app/components/BookmarkMenu/RevertButton';
import AwaitingSelectionNotification from 'app/components/BookmarkMenu/AwaitingSelectionNotification';


function AwaitingSelectionMenu({AppState}) {
  if(!AppState.isUserBookmarking) return null;

  return (
    <React.Fragment>
      <AwaitingSelectionNotification selection ="selection to bookmark"/>
      <RevertButton
        onClick={() => AppState.setMenuBar('MAIN_MENU')}
      />
    </React.Fragment>
  );
}

export default inject('AppState')(observer(AwaitingSelectionMenu));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/AwaitingSelectionMenu.js